"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var menu = /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement("a", {
  target: "_blank",
  rel: "noopener noreferrer",
  href: "https://www.antgroup.com"
}, "1st menu item")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
  icon: /*#__PURE__*/_react.default.createElement(_icons.DownOutlined, null),
  disabled: true
}, /*#__PURE__*/_react.default.createElement("a", {
  target: "_blank",
  rel: "noopener noreferrer",
  href: "https://www.aliyun.com"
}, "2nd menu item (disabled)")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
  disabled: true
}, /*#__PURE__*/_react.default.createElement("a", {
  target: "_blank",
  rel: "noopener noreferrer",
  href: "https://www.luohanacademy.com"
}, "3rd menu item (disabled)")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
  danger: true
}, "a danger item"));
var _default = exports.default = menu;